import { classNames } from 'libs/react';
import { Button } from 'components/Button';
import { FormSelect } from 'components/form/FormSelect';
import { React } from 'libs/react';
import './Pager.scss';
/**
 * @component Pager
 * @since 1.0.0
 */
export function Pager(props) {
    const { style, value, total, hasNext, hasPrev } = Object.assign({ style: 'normal' }, props);
    const className = classNames('pager', 'pager--' + style, { 'pager--has-next': hasNext }, { 'pager--has-prev': hasPrev }, props.className);
    if (total == 0) {
        return null;
    }
    return (React.createElement("div", { className: className },
        React.createElement("div", { className: "pager-body" },
            React.createElement("div", { className: "pager-prev" },
                React.createElement(Prev, Object.assign({}, props))),
            React.createElement("div", { className: "pager-next" },
                React.createElement(Next, Object.assign({}, props))),
            React.createElement("div", { className: "pager-main" },
                React.createElement("div", { className: "pager-value" },
                    React.createElement(Pages, Object.assign({}, props))),
                React.createElement("div", { className: "pager-total" },
                    t('out of'),
                    " ",
                    total)))));
}
/**
 * @component Prev
 * @since 1.0.0
 */
function Pages(props) {
    const { value, total } = props;
    /**
     * @function onChange
     * @since 1.0.0
     */
    function onChange(value) {
        const page = parseInt(value);
        if (page) {
            if (props.onPage) {
                props.onPage(page);
            }
        }
    }
    const options = [];
    for (let i = 1; i <= total; i++) {
        const value = String(i);
        const label = String(i);
        options.push({
            value,
            label
        });
    }
    const page = String(value);
    return (React.createElement(FormSelect, { name: "", value: page, options: options, onChange: onChange }));
}
/**
 * @component Prev
 * @since 1.0.0
 */
function Prev(props) {
    return (React.createElement(Button, { size: "small", style: "pager-prev-button", picto: "arrow-left", label: t('Previous'), onPress: props.onPrev, disabled: props.hasPrev == false }));
}
/**
 * @component Next
 * @since 1.0.0
 */
function Next(props) {
    return (React.createElement(Button, { size: "small", style: "pager-next-button", picto: "arrow-right", label: t('Next'), onPress: props.onNext, disabled: props.hasNext == false }));
}
